module.exports = __webpack_public_path__ + "img/play.bf4d0d61.svg";